import { SignTitle } from '@/components'
import { Form, Modal, Radio, Select, Space } from 'antd'
import { usePutAppend, usePutTag } from './utils'
import { t } from '@/i18n'
const { Option } = Select
const { useForm } = Form
export const Label = props => {
  const { visible, close, tagList, listSelectKey, getEmailListParams, getEmailList } = props
  const [form] = useForm()
  const radioVlaue = Form.useWatch('radio', form) || 1
  const [putAppend] = usePutAppend()
  const [putTag] = usePutTag()
  const onFinish = (values: any) => {
    const { radio, tag_ids } = values
    if (radio == '1') {
      putAppend({ ids: listSelectKey, tag_ids })
        .then(res => {
          form?.resetFields()
          close(true)
          getEmailList(getEmailListParams)
        })
        .catch(err => {})
    }
    if (radio == '2') {
      putTag({ ids: listSelectKey, tag_ids })
        .then(res => {
          form?.resetFields()
          close(true)
          getEmailList(getEmailListParams)
        })
        .catch(err => {})
    }
  }

  return (
    <Modal
      title={<SignTitle show>{t('批量标注')}</SignTitle>}
      visible={visible.visible}
      onCancel={() => {
        close(false)
      }}
      onOk={() => {
        form.submit()
      }}
    >
      <Form onFinish={onFinish} layout="vertical" form={form}>
        <Form.Item name="radio" initialValue={1}>
          {/* <div style={{ display: 'flex' }}> */}
          <Radio.Group>
            <Space size={40}>
              <Radio value={1}>
                <b>{t('标签追加')}</b>
              </Radio>
              <Radio value={2}>
                <b>{t('覆盖标签')}</b>
              </Radio>
            </Space>
          </Radio.Group>
          {/* </div> */}
        </Form.Item>
        <Form.Item name="tag_ids" label={t('标签')} rules={[{ required: radioVlaue == 1 }]}>
          <Select placeholder={t('请选择标签')} mode="multiple" showSearch={false} showArrow>
            {tagList?.map(item => (
              <Option value={item?.id} key={item?.id}>
                {item?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}
